import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { GrFormClose } from "react-icons/gr";
import { StoreContext } from "../../../../store/StoreContext";
import { fetchData } from "../../../helpers/fetchData";
import SpinnerButton from "../../../widget/SpinnerButton";
import { setIsAdd } from "../../../../store/StoreAction";
import { InputSelect, InputText } from "../../../helpers/FormInputs";
import useFetchBranch from "../../../custom-hooks/useFetchBranch";
import { isRoleCashier } from "../../login/login-functions";

const ModalAddCollector = ({ edit }) => {
  const { resultData } = useFetchBranch("/admin/branch/read-branch-all.php");
  const { store, dispatch } = React.useContext(StoreContext);
  const [loading, setLoading] = React.useState(false);
  const { itemEdit, setItemEdit } = edit;
  const isCashier = isRoleCashier(store.credentials.role_name);

  const initVal = {
    collector_id: itemEdit ? itemEdit.collector_id : "",
    collector_bid: itemEdit
      ? itemEdit.collector_bid
      : isCashier
      ? store.credentials.users_branch_id
      : "",
    collector_name: itemEdit ? itemEdit.collector_name : "",
    collector_contact: itemEdit ? itemEdit.collector_contact : "",
  };

  const yupSchema = Yup.object({
    collector_id: Yup.string().required("Required"),
    collector_bid: isCashier ? null : Yup.string().required("Required"),
    collector_name: Yup.string().required("Required"),
    collector_contact: Yup.string().required("Required"),
  });

  const handleClose = () => {
    dispatch(setIsAdd(false));
    setItemEdit(false);
  };

  return (
    <>
      <div className="modal modal-add-employee">
        <div className="display-center">
          <div className="title-container t-exbold notify-info">
            <h4 className="modal-title">
              <span className="color--blue">
                {itemEdit ? "Edit Collector" : "Add Collector"}
              </span>
            </h4>
            <span className="btn--close" onClick={handleClose}>
              <GrFormClose />
            </span>
          </div>
          <div className="bg--white">
            <Formik
              initialValues={initVal}
              validationSchema={yupSchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                // console.log(values);
                fetchData(
                  setLoading,
                  itemEdit
                    ? "/admin/collector/update-collector.php"
                    : "/admin/collector/create-collector.php",
                  values, // form data values
                  null, // result set data
                  "", // success msg
                  "" + values.collector_id + " - ID is already used.", // additional error msg if needed
                  dispatch, // context api action
                  store, // context api state
                  false, // boolean to show success modal
                  false // boolean to show load more functionality button
                );
                setItemEdit(false);
              }}
            >
              {(props) => {
                // console.log(props.isSubmitting);

                return (
                  <Form>
                    <div className="content-box">
                      <InputText
                        label="ID"
                        type="text"
                        name="collector_id"
                        placeholder="Ex. LIP-1234"
                        disabled={itemEdit || loading ? true : false}
                        readOnly={itemEdit ? true : false}
                      />
                    </div>

                    {!isCashier && (
                      <div className="content-box">
                        <InputSelect
                          label="Branch"
                          name="collector_bid"
                          disabled={loading}
                        >
                          {resultData.length > 0 ? (
                            <>
                              <option value=""> -- </option>
                              {resultData.map((item) => (
                                <option
                                  key={item.branch_aid}
                                  value={item.branch_aid}
                                >
                                  {item.branch_city}
                                </option>
                              ))}
                            </>
                          ) : (
                            <option value=""> -- </option>
                          )}
                        </InputSelect>
                      </div>
                    )}

                    <div className="content-box">
                      <InputText
                        label="Name"
                        type="text"
                        name="collector_name"
                        disabled={loading}
                      />
                    </div>

                    <div className="content-box">
                      <InputText
                        label="Mobile No."
                        type="text"
                        name="collector_contact"
                        disabled={loading}
                      />
                    </div>

                    <div className="button-container">
                      <button type="submit" className="btn" disabled={loading}>
                        {itemEdit ? "SAVE" : "ADD"}{" "}
                        {loading && <SpinnerButton />}
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalAddCollector;
